import { makeStyles, Box, Avatar, IconButton, CircularProgress } from '@material-ui/core'

import React, { useState } from 'react'
import CustomButton from '../CustomButton'
import CustomDialog from '../CustomDialog'
import CustomImage from '../CustomImage'
import { Document, Page, pdfjs } from 'react-pdf'
import { BiChevronRight, BiChevronLeft } from 'react-icons/bi'
import HeadingWithCloseIcon from '../HeadingWithCloseIcon'
import { useLead } from '../../hooks/Features/useLeads'
import { loadingAndText } from '../../shared/constants'

const useStyles = makeStyles((theme) => ({
  image: {
    [theme.breakpoints.up('md')]: {
      //
    },
    [theme.breakpoints.up('lg')]: {
      width: '100%',
      height: '60vh',
    },
  },
  width: {
    minWidth: '660px',
  },
}))

export default function PdfDialog({ image, open, handleClose, leadId }) {
  const classes = useStyles()
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`
  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)
  const { sendQuote, loading } = useLead(handleClose)

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages)
  }

  function changePage(offset) {
    setPageNumber((prevPageNumber) => prevPageNumber + offset)
  }

  function previousPage() {
    changePage(-1)
  }

  function nextPage() {
    changePage(1)
  }

  return (
    <CustomDialog open={open} handleClose={handleClose} className={classes.width}>
      <HeadingWithCloseIcon heading="Quote" handleClose={handleClose} />
      <div>
        <Document file={image} onLoadSuccess={onDocumentLoadSuccess}>
          <Page pageNumber={pageNumber} />
        </Document>
        <br />
        <br />
        <Box display="grid" justifyContent="center">
          <div>
            <div className="pagec">
              Page {pageNumber || (numPages ? 1 : '--')} of {numPages || '--'}
            </div>
          </div>
          <div>
            <IconButton color="primary" disabled={pageNumber <= 1} onClick={previousPage}>
              <BiChevronLeft />
            </IconButton>
            <IconButton color="primary" disabled={pageNumber >= numPages} onClick={nextPage}>
              <BiChevronRight />
            </IconButton>
          </div>
        </Box>
      </div>
      <Box display="flex" justifyContent="space-between" marginTop="20px">
        <a href={image} target="_blank" style={{ width: '100%', textDecoration: 'none' }} rel="noreferrer">
          <CustomButton text="Download" />
        </a>
        {leadId!==undefined && <CustomButton
          handleSubmit={() => sendQuote({ leadId: leadId })}
          text={loadingAndText(loading, 'Send Quote')}
          disabled={loading}
        /> }
        

        {/* <CustomButton text="Close" handleSubmit={handleClose} /> */}
      </Box>
    </CustomDialog>
  )
}
